import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/mui/Modal'
import Box from 'components/mui/Box'
import Typography from 'components/mui/Typography'
import Divider from 'components/mui/Divider'
import AppButtonComponent from 'components/mui/AppButtonComponent'
import Button from 'components/mui/Button'
import { IconButton, useTheme } from '@mui/material'
import { Close } from '@mui/icons-material'
import { typography } from 'theme'

/**
 * PAN KYC Info Modal - matches the shared design for KYC details confirmation.
 */
const PanKycInfoModal = ({
  open,
  onClose,
  onConfirm,
  onUpdateContact,
  onReKyc,
  data
}) => {
  const theme = useTheme()

  const {
    fullName,
    panNumber,
    dateOfBirth,
    mobileNumber,
    emailAddress,
    address
  } = data || {}

  const containerSx = {
    bgcolor: '#0B1120',
    borderRadius: '16px',
    p: { xs: 2.5, sm: 3 },
    position: 'relative',
    width: { xs: '100%', sm: 520, md: 560 },
    color: '#FFFFFF',
    boxShadow: '0px 16px 48px rgba(0,0,0,0.4)',
    border: '1px solid rgba(255,255,255,0.08)'
  }

  const sectionLabel = {
    color: '#C7D1E8',
    fontSize: '12px',
    fontWeight: typography.fontWeight.medium,
    mb: 0.5,
    textTransform: 'uppercase',
    letterSpacing: 0.2
  }

  const sectionValue = {
    color: '#FFFFFF',
    fontSize: '15px',
    fontWeight: typography.fontWeight.semibold,
    lineHeight: 1.4
  }

  const twoCol = {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
    gap: 2.5,
    width: '100%'
  }

  const linkButtonSx = {
    color: "",
    textTransform: 'none',
    fontWeight: typography.fontWeight.semibold,
    width: '100%',
    justifyContent: 'center'
  }

  return (
    <Modal open={open} onClose={onClose} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <Box sx={containerSx}>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            color: '#D0D6E5'
          }}
        >
          <Close />
        </IconButton>

        <Box sx={{ textAlign: 'center', mb: 2.5 , }}>
          <Typography
            sx={{
              fontSize: '18px',
              fontWeight: typography.fontWeight.semibold,
              color: '#FFFFFF',
              mb: 0.5
            }}
          >
            Your KYC Information
          </Typography>
          <Typography
            sx={{
              fontSize: '13px',
              color: '#A3B1CC',
              lineHeight: 1.5
            }}
          >
            Confirm your details so we can keep your journey safe and seamless.
          </Typography>
        </Box>

        <Box sx={twoCol}>
          <Box>
            <Typography sx={sectionLabel}>Full Name</Typography>
            <Typography sx={sectionValue}>{fullName || '--'}</Typography>
          </Box>
          <Box>
            <Typography sx={sectionLabel}>Your PAN Number</Typography>
            <Typography sx={sectionValue}>{panNumber || '--'}</Typography>
          </Box>
          <Box>
            <Typography sx={sectionLabel}>Date of Birth</Typography>
            <Typography sx={sectionValue}>{dateOfBirth || '--'}</Typography>
          </Box>
          <Box>
            <Typography sx={sectionLabel}>Mobile number</Typography>
            <Typography sx={sectionValue}>{mobileNumber || '--'}</Typography>
          </Box>
          <Box>
            <Typography sx={sectionLabel}>Email Address</Typography>
            <Typography sx={sectionValue}>{emailAddress || '--'}</Typography>
          </Box>
          <Box>
            <Typography sx={sectionLabel}>Address</Typography>
            <Typography sx={sectionValue}>{address || '--'}</Typography>
          </Box>
        </Box>

        <Box sx={{ mt: 3 }}>
          <AppButtonComponent
            onClick={onConfirm}
            sx={{
              width: '100%',
              backgroundColor: '#4BB2F2',
              color: '#0B1120',
              fontWeight: typography.fontWeight.semibold,
              textTransform: 'none',
              borderRadius: '8px',
              height: 46,
              '&:hover': { backgroundColor: '#3aa2e5' }
            }}
          >
            Confirm and Proceed
          </AppButtonComponent>
        </Box>

        <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.12)' }} />

        <Button variant="text" onClick={onUpdateContact} sx={{    color: "",
    textTransform: 'none',
    fontWeight: typography.fontWeight.semibold,
    width: '100%',
    backgroundColor: "#13172A",
    justifyContent: 'center'}}>
          Update my contact details
        </Button>

        <Divider sx={{ my: 1, borderColor: 'rgba(255,255,255,0.12)' }} />

        <Button variant="text" onClick={onReKyc} sx={{    color: "",
    textTransform: 'none',
    backgroundColor: "#13172A",
    fontWeight: typography.fontWeight.semibold,
    width: '100%',
    justifyContent: 'center'}}>
          Start Re-KYC
        </Button>
      </Box>
    </Modal>
  )
}

PanKycInfoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onUpdateContact: PropTypes.func.isRequired,
  onReKyc: PropTypes.func.isRequired,
  data: PropTypes.shape({
    fullName: PropTypes.string,
    panNumber: PropTypes.string,
    dateOfBirth: PropTypes.string,
    mobileNumber: PropTypes.string,
    emailAddress: PropTypes.string,
    address: PropTypes.string
  })
}

PanKycInfoModal.defaultProps = {
  data: {}
}

export default PanKycInfoModal

